export const isDefined = <T>(
  value: T | null | undefined,
): value is Exclude<T, "null" | "undefined"> =>
  value !== null && value !== undefined;
